import * as React from "react";
const SvgTrendUp24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 14,
        fill: "black",
        viewBox: "0 0 24 14"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M15.8 0H24v8.2h-2V3.414l-9 9-5-5-6.293 6.293-1.414-1.414L8 4.586l5 5L20.586 2H15.8V0Z",
      clipRule: "evenodd"
    })
  );
export default SvgTrendUp24Px;
